import Vue from 'vue'
import Vuex from 'vuex'

import user  from './modules/global/user'
import announcements  from './modules/global/announcements'

import dashboard  from './modules/pages/dashboard'
import feed  from './modules/pages/feed'
import profile  from './modules/pages/profile'
import login  from './modules/pages/login'

import adminAppSettings  from './modules/pages/admin/appSettings'
import adminAppEditUser  from './modules/pages/admin/appEditUser'
import adminAppViewDashboard  from './modules/pages/admin/appViewDashboard'
import adminAppAdvertisements from './modules/pages/admin/appAdvertisements'

Vue.use(Vuex)

export const store = new Vuex.Store({
    //strict: true,
    modules: {
        user,
        dashboard,
        feed,
        profile,
        login,
        announcements,
        adminAppSettings,
        adminAppEditUser,
        adminAppViewDashboard,
        adminAppAdvertisements,
    },
})

// Load the initial user's data and watch for AuthChanges + Document change
store.dispatch('user/loadUserAndWatchForChanges');





// WEBPACK FOOTER //
// ./src/stores/index.js